import { size1, size14, size16 } from '../theme/scale';
export function isMaxWidth(width) {
  return window.matchMedia(`(max-width: calc(${width} - ${size1}))`).matches;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isValidDate = function (date) {
  return date !== 'Invalid Date' && !isNaN(date);
};
export const labelFontSize = ({
  smallLabel
}) => smallLabel ? size14 : size16;
//# sourceMappingURL=helpers.js.map